import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

register('more-recipes', {
  onLoad() {
    /**
     * Initialise recipes slider
     */
    const $moreRecipesSlider = this.container.querySelector('.recipes__grid--slider');

    new Flickity($moreRecipesSlider, {
      freeScroll: false,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'left',
      watchCSS: true,
      wrapAround: false,
      groupCells: true,
    });
  },
});
